var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.297 7.368a4.838 4.838 0 1 0 0 9.675 4.838 4.838 0 0 0 0-9.675Zm-2.962 4.837a2.963 2.963 0 1 1 5.925 0 2.963 2.963 0 0 1-5.925 0Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.303.88c4.975.003 10.044 2.938 11.384 8.856 1.553 6.861-2.73 12.56-6.24 15.931-2.876 2.776-7.425 2.774-10.312.002v-.002C3.636 22.297-.646 16.585.907 9.723 2.254 3.805 7.327.877 12.303.88Zm-9.566 9.257C3.853 5.23 8.03 2.752 12.3 2.755c4.272.003 8.446 2.487 9.557 7.394 1.321 5.838-2.295 10.888-5.71 14.167l-.002.002a5.554 5.554 0 0 1-7.711 0c-3.403-3.28-7.02-8.343-5.698-14.18Z",
    fill: "currentColor"
  })));
};
export default SvgLocation;